import { accountId } from '../lib/jwt';
import { resetIdentifiedAccount } from '@/lib/identifyAccountInSegmentOnce';

function ssoUuid(): string | null {
  try {
    return accountId();
  } catch (_e) {
    return null;
  }
}

export function clearCache() {
  const currentAccountId = ssoUuid();
  if (!currentAccountId) {
    // no user logged in, clear session storage
    window.sessionStorage.clear();
    resetIdentifiedAccount();
  } else if (window.sessionStorage.registrationID !== currentAccountId) {
    // user account was created in the current session, but is not the current user
    window.sessionStorage.clear();
    window.sessionStorage.setItem('registrationID', currentAccountId);
    resetIdentifiedAccount();
  }
}

export default {
  clearCache,
};
